import { BrandingImage, BrandingStyle } from "@bcm-dev/bcms-vite";
import PageLayoutContainer from "components/shared/containers/PageLayoutContainer";
import React from "react";
import EDEStatementsMainNavView from "../EDEStatementsMainNavView";
import EDEStatementsPageFooterView from "../EDEStatementsPageFooterView";
import EDEStatementsPageHeaderView, { EDEStatementsMobilePageHeaderView } from "../EDEStatementsPageHeaderView";
import "./styles.css";

/**
 * @function EDEStatementsPageContentView
 * @param {React.Component} children - Content that's contained in this page.
 * @returns {React.Component}
 * @example
 * <EDEStatementsPageContentView>
 *  <LeftColumn />
 *  <RightColumn />
 * </EDEStatementsPageContentView>
 */
export default function EDEStatementsPageContentView(props) {
  const showHeader = props.showHeader ?? true;
  const hidePageBody = props.hidePageBody ?? false;

  return (
    <BrandingStyle style={ hidePageBody ? {} : { "backgroundImage":"url([[main_bg_image_abi22]])" } } className="ede-statements-page-content-view flex-container flex-vertical" >
      { showHeader && 
      <>
        <EDEStatementsPageHeaderView>
          <div className="upper-header-wrapper flex-container flex-horizontal align-center">
            <div className="flex-width">
              <a href="#/accountSummary" data-point="EDE_Statements_Page_Header_Logo_Container">
                <BrandingImage id="ede_statements_filogo_abi22" className="page-header-logo" />
              </a>
            </div>
            {/*<UtilityNavView/>*/}
          </div>
          <EDEStatementsMainNavView/>
        </EDEStatementsPageHeaderView>
        <EDEStatementsMobilePageHeaderView />
      </>
      }
      <PageLayoutContainer className={ hidePageBody ? "visibility-hidden" : "" }>
        {props.children}
      </PageLayoutContainer>
      { !hidePageBody && <EDEStatementsPageFooterView /> }
      
    </BrandingStyle>
  );
}